import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { FileFilter } from "../../../Constant";
import { Btn, LI, UL } from "../../../AbstractElements";
import { FILE_SIDE_BUTTON } from "../../../Data/FileManager";
import PricingPlans from "./PricingPlans";
import { StorageSection } from "./StorageSection";

const FileSideBar = () => {
  const [IsOpen, setIsOpen] = useState(false);
  const OnHandelClick = () => {
    setIsOpen(!IsOpen);
  };

  return (
    <>
      <Col xl="3" className="box-col-30">
        <div className="md-sidebar">
          <Btn color="primary" className="md-sidebar-toggle" onClick={OnHandelClick}>{FileFilter}          </Btn>
          <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${IsOpen ? "open" : ""}`}>
            <div className="file-sidebar">
              <Card>
                <CardBody>
                  <UL className="simple-list">
                    {FILE_SIDE_BUTTON.map((item, index) => (
                      <LI key={index} className="border-0">
                        <div className={item.className}>{item.icon}{item.title}</div>
                      </LI>
                    ))}
                  </UL>
                  <hr style={{ opacity: 0.25 }} />
                  <StorageSection />
                  <PricingPlans />
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </Col>
    </>
  );
};
export default FileSideBar;
